/**
 *
 * TemperatureControlFormItem
 *
 */

import React, { useMemo } from 'react'
import { Form } from '@nv/react-commons/src/Components'
import { FIELDS } from 'components/OCForm/constants'
import {
  OptionDescription,
  OptionTitle,
  OptionWrapper,
  StyledRadio,
  StyleRadioGroup
} from './TemperatureControlFormItem.styles'
import { useIntl } from 'hooks/common'
import { TemperatureControlFormItemProps } from './TemperatureControlFormItem.interface'

export const TemperatureControlFormItem = ({
  form: { getFieldDecorator },
  disabled,
  formItem: FormItem = Form.Item,
  initialValue,
  ocSettings,
  country
}: TemperatureControlFormItemProps) => {
  // hooks
  const intl = useIntl()

  // variables
  const enabledTemperatureRanges = useMemo(() => (ocSettings?.enabledTemperatureRanges || []) as string[], [ocSettings])
  const filteredEnabledTemperatureRanges = useMemo(() => {
    if (country === 'MY') {
      return enabledTemperatureRanges
    }
    // NOTE: filter the enabled temperature ranges for 'COOL' (currently only supported for MY shippers).
    return enabledTemperatureRanges.filter(d => d !== 'COOL')
  }, [country, enabledTemperatureRanges])

  return (
    <FormItem label={intl.formatMessage({ id: 'oc.temperature_control_required' })} isInlineBlockTitle>
      {getFieldDecorator(FIELDS.TEMPERATURE_RANGE, {
        initialValue: initialValue,
        rules: []
      })(
        <StyleRadioGroup orientation='vertical' disabled={disabled}>
          <StyledRadio value=''>
            <OptionWrapper>
              <OptionTitle>{intl.formatMessage({ id: 'oc.temperature_range.ambient.title' })}</OptionTitle>
              <OptionDescription>{intl.formatMessage({ id: 'oc.temperature_range.ambient.desc' })}</OptionDescription>
            </OptionWrapper>
          </StyledRadio>

          {filteredEnabledTemperatureRanges.map((tr, i) => (
            <StyledRadio key={i} value={tr}>
              <OptionWrapper>
                <OptionTitle>
                  {intl.formatMessage({ id: `oc.temperature_range.${tr.toLowerCase()}.title` })}
                </OptionTitle>
                <OptionDescription>
                  {intl.formatMessage({ id: `oc.temperature_range.${tr.toLowerCase()}.desc` })}
                </OptionDescription>
              </OptionWrapper>
            </StyledRadio>
          ))}
        </StyleRadioGroup>
      )}
    </FormItem>
  )
}
